import { CustomParamScenario, CustomField } from './model';
import { fetchApi } from './common';

// 获取自定义字段列表
export async function listCustomFields(scenario?: CustomParamScenario) {
  const params = new URLSearchParams();
  if (scenario) {
    params.append('scenario', scenario);
  }
  const queryString = params.toString();
  const url = queryString ? `/api/doctor_view/custom_fields?${queryString}` : '/api/doctor_view/custom_fields';
  return fetchApi<CustomField[]>(url, 'GET');
}

// 创建自定义字段
export async function createCustomField(
  name: string,
  hint: string,
  scenarios: CustomParamScenario[],
  isEnabled: boolean = true
) {
  return fetchApi<CustomField>('/api/doctor_view/custom_fields', 'POST', {
    name,
    hint,
    scenarios,
    is_enabled: isEnabled
  });
}

// 更新自定义字段
export async function updateCustomField(
  id: string,
  name: string,
  hint: string
) {
  return fetchApi<CustomField>(`/api/doctor_view/custom_fields/${id}`, 'PUT', {
    name,
    hint
  });
}

// 设置自定义字段启用状态
export async function setCustomFieldEnabled(id: string, isEnabled: boolean) {
  return fetchApi<CustomField>(`/api/doctor_view/custom_fields/${id}/set_enabled`, 'PUT', {
    is_enabled: isEnabled
  });
}